import AvatarContainer from './AvatarContainer';

export default AvatarContainer;
